<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAllCashReceipt('cashReceiptList')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon @click="showFilters = !showFilters">{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card
          ><v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="accountReceivableStatusList"
                label="Choose Status..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                item-text="name"
                item-value="id"
              >
              </v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Receipt Amount:</span>
              <v-chip>
                <span>{{ totalReceiptAmount | decFormat(6) }}</span>
              </v-chip>

              <span>Total Discount Amount:</span>
              <v-chip>
                <span>{{ totalDiscountlAmount | decFormat(6) }}</span>
              </v-chip>

              <span>Total Damage Amount:</span>
              <v-chip>
                <span>{{ totalDamageAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="cashReceiptListByDateList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.issueDate }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.fromDate }}</td>
              <td>{{ props.item.toDate }}</td>
              <td>{{ props.item.currency }}</td>
              <td>{{ props.item.rate | decFormat(6) }}</td>
              <td style="text-align: right">
                {{ props.item.receiptAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.discount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.damage | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Product list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="township"
                label="Township"
                type="text"
                v-model="customerQueryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="creditLevelList"
                v-model="customerQueryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="statusList"
                label="Status"
                v-model="customerQueryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="customerHeader"
                :items="customerList"
                class="elevation-1"
                :loading="showCustomerListLoading"
                :total-items="customerTotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="customerPagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedCustomerList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.advancedAmount | decFormat(6) }}</td>
                  <td>{{ props.item.creditLevel.name }}</td>
                  <td>
                    <v-icon
                      v-if="props.item.status == 'ACTIVE'"
                      medium
                      color="green"
                      >check_circle</v-icon
                    >
                    <v-icon v-else medium color="red">cancel</v-icon>
                  </td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setCustomer">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--print all-->
    <div
      id="cashReceiptList"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Account Receivable Report</p>
      </div>
      <br />
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ queryParams.fromDate }}] To Date: [{{
            queryParams.toDate
          }}]
        </p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Cash Receipt No.
              </th>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">
                Customer Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Start Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                End Date
              </th>
              <th style="border: 1px solid black; text-align: center">Cur</th>
              <th style="border: 1px solid black; text-align: center">Rate</th>
              <th style="border: 1px solid black; text-align: center">
                Receipt Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Discount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Damage
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in allCashReceiptListByDateList"
            :key="index"
          >
            <tr>
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueNo }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDate }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.fromDate }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.toDate }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.currency }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.rate | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.receiptAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.discount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.damage | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr style="border: 1px solid black; text-align: right">
            <td style="border: 1px solid black; font-weight: bold" colspan="7">
              Grand Total
            </td>
            <td style="border: 1px solid black; text-align: right">
              {{ totalReceiptAmount | decFormat(6) }}
            </td>
            <td style="border: 1px solid black; text-align: right">
              {{ totalDiscountlAmount | decFormat(6) }}
            </td>
            <td style="border: 1px solid black; text-align: right">
              {{ totalDamageAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import { accountReceivableService } from "../../services/account-receivable-service";
import { shopService } from "../../services/shop-service";

export default {
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Account Receivable Report",
        disabled: true,
      },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerIds: [],
      shopId: "",
    },
    customerQueryParams: {
      code: "",
      name: "",
      township: "",
      creditLevelId: "",
      status: "",
    },
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "code",
      totalItems: 0,
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issue_date",
      totalItems: 0,
    },
    headers: [
      { text: "Cash Receipt No.", align: "left", sortable: false },
      { text: "Date", align: "left", value: "issue_date" },
      { text: "Customer Name", align: "left", sortable: false },
      { text: "Start Date", align: "left", value: "from_date" },
      { text: "End Date", align: "left", value: "to_date" },
      { text: "Cur", align: "left", sortable: false },
      { text: "Rate", align: "left", sortable: false },
      { text: "Receive Amount", align: "left", sortable: false },
      { text: "Discount", align: "left", sortable: false },
      { text: "Damage", align: "left", sortable: false },
    ],
    customerHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Address", value: "address" },
      { text: "Advanced Amount", value: "advancedAmount" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    accountReceivableStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    customerTotalRows: 0,
    totalReceiptAmount: 0,
    totalDiscountlAmount: 0,
    totalDamageAmount: 0,
    totalRows: 0,
    clonequeryParams: new Object(),
    rowsPerPageItems: [25, 50, 100],
    showCustomerListLoading: false,
    showCustomerListDialog: false,
    printAllButtonLoading: false,
    decimalFormat: "",
    selectedCustomerList: [],
    creditLevelList: [],
    customerList: [],
    cashReceiptListByDateList: [],
    allCashReceiptListByDateList: [],
    showListLoading: [],
    shopList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getCashReceiptListingByDate();
      },
      deep: true,
    },
    customerPagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    this.customerQueryParams.status = "ACTIVE";
    if (this.$route.query.fromDate) {
      this.queryParams.code = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.customerIds) {
      this.queryParams.customerIds = this.$route.query.customerIds;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getCreditLevels();
    this.getAllShop();
    this.getCashReceiptListingByDate();
    this.decimalFormat = commonService.formatdecimal();
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "cash-receipt-listing-by-date",
        query: this.queryParams,
      });
      this.getCashReceiptListingByDate();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },

    getCashReceiptListingByDate() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountReceivableService
        .getCashReceiptListingByDate(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.cashReceiptListByDateList =
              res.data.cashReceipListingByDateDTOs;
            this.totalRows = res.data.totalElements;
            this.totalReceiptAmount = res.data.totalReceiptAmount;
            this.totalDiscountlAmount = res.data.totalDiscountAmount;
            this.totalDamageAmount = res.data.totalDamageAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.township = "";
      this.customerQueryParams.creditLevelId = "";
      this.customerQueryParams.status = "";
      this.selectedCustomerList = [];
      this.queryParams.customerIds = [];
      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showProductListDialog)
      );
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----",
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.customerPagination.page;
      this.customerQueryParams.size = this.customerPagination.rowsPerPage;
      this.getCustomerList();
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.customerList.slice();
      }
    },
    getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showCustomerListLoading = false;
        });
    },
    printAllCashReceipt(divName) {
      this.printAllButtonLoading = true;
      accountReceivableService
        .getAllCashReceiptListingByDate(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allCashReceiptListByDateList =
              res.data.cashReceipListingByDateDTOs;
            this.totalReceiptAmount = res.data.totalReceiptAmount;
            this.totalDiscountlAmount = res.data.totalDiscountAmount;
            this.totalDamageAmount = res.data.totalDamageAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>